import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CopyrightFooter, Error, LanguageSelector } from '~/Components';
import { makeStyles } from '~/UIKit/Style';
import { OnboardingSideSplash, OnboardingStudio, useOnboarding } from './';
import { onboardingValidationScheme } from './helpers/useVerification';
import { Helmet } from 'react-helmet';
import { useUser } from '~/Hooks';
import { onboardingPage } from './IOnboardingData.model';
import IMAGES from '~/Constants/Images.constants';

const useStyles = makeStyles((theme) => ({
  onboardingContainerWrapper: {
    overflow: 'overlay',
    maxHeight: '100vh',
  },
  onboardingContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    width: 1200,
    minWidth: '100%',
    position: 'relative',
    letterSpacing: 0.5,
    fontWeight: 300,
    fontSize: '13px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      height: 'auto',
      width: 'auto',
      minWidth: 'auto',
    },
  },
  onboardingContent: {
    paddingTop: 40,
    overflowY: 'auto',
    flex: 1,
  },
  onboardingHeader: {
    height: 64,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);',
  },
  logo: {
    height: 20,
  },
}));

export const OnboardingPostLogin = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const {
    initialValues,
    validateForm,
    countryList,
    categoryList,
    isStudioSetupDone,
    isAlreadyAUser,
    networkError,
    onCreateProviderPostLogin,
  } = useOnboarding({ postLogin: true });
  const { currentUser } = useUser();

  return (
    <div className={classes.onboardingContainerWrapper}>
      <div className={classes.onboardingHeader}>
        <img className={classes.logo} src={IMAGES.ONBOARDING.uscLogo} />
        <LanguageSelector simple />
      </div>
      <Helmet>
        <title>{t('SEO.onboarding.title')}</title>
        <meta name="description" content={t('SEO.onboarding.description')} />
      </Helmet>
      <div className={classes.onboardingContainer}>
        <OnboardingSideSplash pageName={onboardingPage.USC} />
        <div className={classes.onboardingContent}>
          <Formik
            initialValues={{ ...initialValues, aggregatorType: 1 }}
            onSubmit={() => {}}
            validate={(values) =>
              validateForm({ ...values, email: currentUser?.email || '', aggregatorType: 1 })
            }
            enableReinitialize
            validationSchema={() => onboardingValidationScheme(t, isAlreadyAUser)}
          >
            {({ errors, touched }) => (
              <Form>
                <Error error={networkError} />
                <OnboardingStudio
                  countryList={countryList}
                  studioTypes={categoryList}
                  isStudioSetupDone={isStudioSetupDone}
                  onDoneSettingUpStudio={onCreateProviderPostLogin}
                  errors={errors}
                  touched={touched}
                  postLogin
                />
              </Form>
            )}
          </Formik>
          <CopyrightFooter usc />
        </div>
      </div>
    </div>
  );
};

export default OnboardingPostLogin;
